import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

// ** Reactstrap Imports
import { Card, CardHeader, CardTitle, CardBody } from 'reactstrap'

const CustomTooltip = data => {
  if (data.active && data.payload) {
    return (
      <div className='recharts-custom-tooltip'>
        <p className='fw-bold mb-0'>{data.label}</p>
        <hr />
        <div className='active'>
          {data.payload.map(i => {
            return (
              <div className='d-flex align-items-center' key={i.dataKey}>
                <span
                  className='bullet  bullet-sm bullet-bordered me-50'
                  style={{
                    backgroundColor: i.fill
                  }}
                ></span>
                <span className='align-middle text-capitalize me-75'>
                  {i.dataKey} : {i.payload[i.dataKey]}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return null
}

const InboundChart = ({data}) => {

  const mainColors = ['#826af9', '#9f87ff', '#d2b0ff', '#78AEFF', '#F74D52', '#a61fad', '#8BD742', '#BCC1C8']

  const newData = data.map((el, i) => {
    return {
      name : el.type || el.yard,
      bgColor: mainColors[i],
      bag: el.bagUnits,
      bagger: el.baggerUnits,
      bulk: el.bulkUnits
    }
  })

  return (
    <Card>
      {/* <CardHeader className='flex-sm-row flex-column justify-content-sm-between justify-content-center align-items-sm-center align-items-start'>
        <CardTitle tag='h4'>{total} Units in total</CardTitle>
      </CardHeader> */}

      <CardBody>
        <div className='d-flex justify-content-center align-items-center flex-wrap mb-2'>
          {['Bag', 'Bagger', 'Bulk'].map((el, i) => <div className='me-1' key={i}>
          <span className='bullet bullet-sm bullet-bordered me-50' style={{ backgroundColor: mainColors[i] }}></span>
          <span className='align-middle me-75'>{el}</span>
        </div>
          )}
        </div>
        <div className='recharts-wrapper bar-chart' style={{ height: '500px'}}>
          <ResponsiveContainer>
            <BarChart data={newData} barSize={22}>
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis dataKey='name' />
              <YAxis />
              <Tooltip content={CustomTooltip} />
              {['bag', 'bagger', 'bulk'].map((el, i) => (
                i === 2 ? <Bar key={i} dataKey={el} stackId='a'
                 fill={mainColors[i]}  radius={[15, 15, 0, 0]} /> : <Bar key={i} dataKey={el}
                  stackId='a' fill={mainColors[i]}  />
              )
               )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardBody>
    </Card>
  )
}
export default InboundChart
